import { Lock, Truck, RotateCcw } from "lucide-react";

type Variant = "compact" | "default";

const METHODS = [
  { slug: "googlepay", label: "Google Pay", color: "5F6368" },
  { slug: "phonepe", label: "PhonePe", color: "5F259F" },
  { slug: "paytm", label: "Paytm", color: "00BAF2" },
  { slug: "visa", label: "Visa", color: "1A1F71" },
  { slug: "mastercard", label: "Mastercard", color: "EB001B" },
];

/**
 * Trust strip near the buy CTA / cart checkout: familiar payment marks,
 * dispatch expectation and the returns promise. Checkout runs on Razorpay.
 */
export function PaymentTrustBadges({ variant = "default" }: { variant?: Variant }) {
  const isCompact = variant === "compact";
  return (
    <div
      data-testid="payment-trust-badges"
      className={
        isCompact
          ? "space-y-1 px-1 pt-1"
          : "mt-4 space-y-1.5 rounded-xl border border-border/70 bg-brand-soft/30 px-3.5 py-2.5"
      }
    >
      <div className="flex flex-wrap items-center justify-center gap-x-2.5 gap-y-1">
        {METHODS.map((m) => (
          <img
            key={m.slug}
            src={`https://cdn.simpleicons.org/${m.slug}/${m.color}`}
            alt={m.label}
            width={isCompact ? 26 : 30}
            height={isCompact ? 13 : 15}
            loading="lazy"
            decoding="async"
            className={isCompact ? "h-[13px] w-auto opacity-80" : "h-[15px] w-auto opacity-85"}
          />
        ))}
        <span className="inline-flex items-center gap-1 text-[9.5px] font-medium text-muted-foreground">
          <Lock className="h-3 w-3 text-brand" aria-hidden /> UPI · Cards · Net banking
        </span>
      </div>
      <div
        className={`flex flex-wrap items-center justify-center gap-x-2 gap-y-0.5 ${
          isCompact ? "text-[9.5px]" : "text-[11px]"
        } leading-none text-muted-foreground`}
      >
        <span className="inline-flex items-center gap-1 whitespace-nowrap">
          <Truck className="h-3 w-3 text-brand" aria-hidden /> Dispatch in 24 hours · delivery 3–5
          days
        </span>
        <span aria-hidden className="opacity-40">
          ·
        </span>
        <span className="inline-flex items-center gap-1 whitespace-nowrap">
          <RotateCcw className="h-3 w-3 text-brand" aria-hidden /> Money-back promise
        </span>
      </div>
    </div>
  );
}
